import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css/animate.css";
import "font-awesome/css/font-awesome.css";
import logo from "./logo.svg";
import "./Signup.css";
import Session from "react-session-api";
import { useState } from "react";
import axios from "axios";
import ReturnClass from "./ReturnClass";
import { useNavigate } from "react-router-dom";
import BindControlsValues from "../Dashboard/BindControls";


export default function Otp() {
    const apiurl = window.SERVICE_URL;
    const navigate = useNavigate();
    debugger
    if (localStorage.getItem("usersession") != null) {
        const res = JSON.parse(localStorage.getItem("usersession"));
        ReturnClass.EmailID = res.EmailID;
        ReturnClass.MobileNumber = res.MobileNumber;
        ReturnClass.ID = res.ID;
        ReturnClass.PartnerID = res.PartnerID;
    }

    const IsVerifyOptions = {
        IsMobileVerification: false,
        IsEmailVerification: false
    }

    const IsChecked = (e) => {
        e.preventDefault();
        debugger;
        var IsMob = document.getElementById("MobileNumber").checked;
        var IsEmail = document.getElementById("EmailID").checked;
        if (IsMob && IsEmail) {
            BindControlsValues.OTPFor = 3;
            IsVerifyOptions.IsMobileVerification = true;
            IsVerifyOptions.IsEmailVerification = true;
            otpsend(e, ReturnClass.EmailID, ReturnClass.MobileNumber);
        }
        else if (IsMob && !IsEmail) {
            IsVerifyOptions.IsMobileVerification = true;
            BindControlsValues.OTPFor = 1;
            otpsend(e, ReturnClass.MobileNumber, "");
        }
        else if (!IsMob && IsEmail) {
            IsVerifyOptions.IsEmailVerification = true;
            BindControlsValues.OTPFor= 2;
            otpsend(e, "", ReturnClass.EmailID);
        }
        else {
            alert('please checked one check box :');
        }
    }

    const otpsend = async (e, Mobile, EmailID) => {
        e.preventDefault();

      //  debugger;
        const sendotp = {
            PartnerID: ReturnClass.PartnerID.toLocaleString(),
            OTPMobile: "",
            OTPEmail: "",
            AddedOn: new Date(),
            IsUsed: false,
            VerifiedOn: new Date(),
            OTPFor: BindControlsValues.OTPFor,
            UserID: ReturnClass.PartnerID,
            VerifyOTPFor: 1,
            MobileNo: Mobile,
            EmailID: EmailID,
        }
     //   debugger
        await axios.post(apiurl+`api/SaveOTPForRegistration`, sendotp, {
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((result) => {
                debugger;
                console.log(result + "1");
                localStorage.setItem("VerifyOptions", JSON.stringify(IsVerifyOptions));
                navigate("/Verify-otp");
                console.log(result);



            });
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-4 px-5 py-2 d-flex justify-content-center align-items-center">
                        <div>
                            <center>
                                <img src={logo} alt="brand-logo" className="w-50 mb-3" />
                            </center>
                            <form>
                                <div className="form-check p-3 border mb-3 ">
                                    <input
                                        type="checkbox"
                                        className="form-check-input ml-2"
                                        name="EmailID"
                                        id="EmailID"
                                    />
                                    <label className="form-check-label ml-5" htmlFor="emailotp">
                                        {ReturnClass.EmailID}
                                    </label>
                                </div>
                                <div className="form-check p-3 border  mb-3 ">
                                    <input
                                        type="checkbox"
                                        className="form-check-input ml-2"
                                        id="MobileNumber"
                                    />
                                    <label className="form-check-label ml-5" htmlFor="mobileotp">
                                        {ReturnClass.MobileNumber}
                                    </label>
                                </div>

                                <button
                                    type="submi"
                                    className="btn btn-primary btn-block mb-3"
                                    onClick={IsChecked}
                                >
                                    Send OTP
                                </button>
                            </form>
                        </div>
                    </div>
                    <div className="col-md-8 rightbox">
                        <h3 className="title mt-3">Welcome to Questopedia</h3>
                        <div className="yoc-login__desc">
                            The Question Paper Generator Platform{" "}
                        </div>
                        <h6 className="brand-title" align="center">
                            Questopedia provides the services to care for business
                        </h6>

                        <div className="row mt-5">
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">faeture 1</h4>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">faeture 2</h4>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">faeture 3</h4>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">faeture 4</h4>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">faeture 5</h4>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="feature-box">
                                    <div className="iconbox">
                                        <i className="fa fa-newspaper-o"></i>
                                    </div>
                                    <h4 className="featureheading">faeture 6</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}